import { RunBlockKey } from 'shared/hooks/useReportProgress';

export const RUN_BLOCK_EXPECTED_SECONDS: Record<RunBlockKey, number> = {
  robotsTxt: 1,
  llmsTxt: 1,
  schemaOrg: 1,
  businessInsights: 14.7,
  visibilityScore: 531.7,
  businessName: 13.2,
  businessAddress: 13.8,
  targetAudience: 18.4,
  geographicFocus: 14,
  conversationalWriting: 19.5,
  statisticalEvidence: 22.4,
  contentFreshness: 16.4,
};

export const formatElapsed = (seconds: number): string => {
  const s = Math.max(0, Math.floor(seconds));
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const formatExpected = (seconds: number): string => {
  if (seconds < 90) return `~${Math.round(seconds)}s`;
  return `~${Math.round(seconds / 60)} min`;
};

export const getSectionTiming = (
  keys: RunBlockKey[],
  blockStartedAt: Record<RunBlockKey, string | null>
): { startedAt: string | null; expectedSeconds: number } => {
  const startedTimes = keys
    .map(key => blockStartedAt[key])
    .filter((value): value is string => Boolean(value))
    .sort();

  return {
    startedAt: startedTimes[0] ?? null,
    expectedSeconds: keys.reduce(
      (total, key) => total + RUN_BLOCK_EXPECTED_SECONDS[key],
      0
    ),
  };
};
